var React = require('react');

function Quote (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.0985 52L31.5558 0H0V52H15.0985ZM52.5427 52L69 0H37.4442V52H52.5427Z","fill":"#8024EF"}));
}

Quote.defaultProps = {"width":"69","height":"52","viewBox":"0 0 69 52","fill":"none"};

module.exports = Quote;

Quote.default = Quote;
